import Swiper from 'swiper/bundle';

export const newsSwiper = {
  init: ()=>{
    const swiper = new Swiper('#news-swiper', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      centeredSlides : true,
      slidesPerView: 1.2,
      spaceBetween: 10,
      breakpoints: {
        768: {
          centeredSlides : false,
          slidesPerView: 2,
          spaceBetween: 20,
        }
      }
    });
  }
}
